import React from 'react';
import { FormattedMessage } from 'react-intl';
import ExpandedFiltersOverlay from '../ExpandedFiltersOverlay';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { TextButton } from '@bibliocommons/base-buttons';

const propTypes = {
  fieldId: React.PropTypes.string,
  handleToggleExpandedField: React.PropTypes.func.isRequired,
  handleExpandField: React.PropTypes.func.isRequired,
  handleCloseExpandField: React.PropTypes.func
};

class ExpandFilterLink extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    this.bindAll('handleClick', 'handleClose');
  }

  handleClick() {
    this.setState({
      open: true
    });
    this.props.handleExpandField(this.props.fieldId);
  }

  handleClose() {
    const { handleCloseExpandField } = this.props;

    if (handleCloseExpandField) {
      handleCloseExpandField();
    }

    this.setState({
      open: false
    });
  }

  render() {
    return (
      <div>
        <TextButton
          className="cp-expand-filter-link"
          handleClick={this.handleClick}
          data-test-id={`${this.props.fieldId}-show-more`}
          block>
          <FormattedMessage id="Facets.showMore" />
        </TextButton>
        <ExpandedFiltersOverlay {...this.props} open={this.state.open} handleClose={this.handleClose} />
      </div>
    );
  }
}

ExpandFilterLink.propTypes = propTypes;

export default ExpandFilterLink;



// WEBPACK FOOTER //
// ./app/components/shared/Facets/ExpandFilterLink/ExpandFilterLink.jsx